<!--巡回日报  -->
<template>
	<div class="info-box">
		<el-dialog title="巡回日报信息" v-if="dialogVisible" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="1000px" :before-close="cancle"
			top="3vh">
			<div>
						<div class="info-title">车辆信息:</div>
						<!--  -->
						<div class="mt5">
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 巡回计划: </span>
									<span class="ml15"> {{rowData.planCode||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 计划日期: </span>
									<span class="ml15"> {{rowData.planDate||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 车辆: </span>
									<span class="ml15"> {{rowData.licensePlate||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 路线: </span>
									<span class="ml15"> {{rowData.routeName||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 出发时间: </span>
									<span class="ml15"> {{rowData.drawOutTime||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 回车时间: </span>
									<span class="ml15"> {{rowData.returnTime||'无'}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 开始里程: </span>
									<span class="ml15"> {{rowData.startKilometrage||0}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 结束里程: </span>
									<span class="ml15"> {{rowData.endKilometrage||0}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 行走距离: </span>
									<span class="ml15"> {{rowData.distance||0}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 加油量： </span>
									<span class="ml15"> {{rowData.refuelNumber||0}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 加油余额: </span>
									<span class="ml15"> {{rowData.refuelMoney||0}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 油卡余额： </span>
									<span class="ml15"> {{rowData.cardBalance||0}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> ETC使用金额: </span>
									<span class="ml15"> {{rowData.etcMoney||0}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> ETC余额: </span>
									<span class="ml15"> {{rowData.etcBalance||0}}</span>
								</div>
							</div>
							<!--  -->
							<!--  -->
							<div class="flex nc-box">
								<div class="flex-1">
									<span class="info-name"> 主路线员: </span>
									<span class="ml15"> {{rowData.mainUserName||'无'}}</span>
								</div>
								<div class="flex-1">
									<span class="info-name"> 副路线员: </span>
									<span class="ml15"> {{rowData.secUserName||'无'}}</span>
								</div>
							</div>
							<!--  -->

							<!--  -->
						</div>

					</div>
				<!--  -->
					<!-- 配送客商情况 -->
			
				<div class="info-title mt20">配送客商情况:</div>
				<el-table class="mt20" :data="rowData.tableFormData1.tableDatas" ref="multipleTable"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333',height:'25px'}"
					max-height="300px" border style="width: 100%">
					 <el-table-column v-show="rowData.tableFormData1.tableDatas" v-for="(value, index) in rowData.tableFormData1.titles" :key="index"
						:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
						<template slot-scope="scope">
							{{scope.row.datas[index]}}
						</template>
					</el-table-column>
				</el-table>
			
				<div class="info-title mt20">车辆检查情况:</div>
				<el-table class="mt20" :data="rowData.tableFormData2.tableDatas" ref="multipleTable"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333',height:'25px'}"
					max-height="300px" border style="width: 100%">
					 <el-table-column v-show="rowData.tableFormData2.tableDatas" v-for="(value, index) in rowData.tableFormData2.titles" :key="index"
						:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
						<template slot-scope="scope">
							{{scope.row.datas[index]}}
						</template>
					</el-table-column>
				</el-table>
				
				<div class="info-title mt20">配送收款合计:</div>
				<el-table class="mt20" :data="rowData.tableFormData3.tableDatas" ref="multipleTable"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333',height:'25px'}"
					max-height="300px" border style="width: 100%">
					 <el-table-column v-show="rowData.tableFormData3.tableDatas" v-for="(value, index) in rowData.tableFormData3.titles" :key="index"
						:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
						<template slot-scope="scope">
							{{scope.row.datas[index]}}
						</template>
					</el-table-column>
				</el-table>
			
				<div class="info-title mt20">配送数量汇总:</div>
				<el-table class="mt20" :data="rowData.tableFormData4.tableDatas" ref="multipleTable"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333',height:'25px'}"
					max-height="300px" border style="width: 100%">
					 <el-table-column v-show="rowData.tableFormData4.tableDatas" v-for="(value, index) in rowData.tableFormData4.titles" :key="index"
						:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
						<template slot-scope="scope">
							{{scope.row.datas[index]}}
						</template>
					</el-table-column>
				</el-table>
				<div class="info-title mt20">配送客商数量汇总:</div>
				<el-table class="mt20" :data="rowData.tableFormData5.tableDatas" ref="multipleTable"
					:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333',height:'25px'}"
					max-height="300px"
					 border style="width: 100%">
					 <el-table-column v-show="rowData.tableFormData5.tableDatas" v-for="(value, index) in rowData.tableFormData5.titles" :key="index"
						:show-overflow-tooltip="true" :label="value.title" :min-width="value.maxWidth">
						<template slot-scope="scope">
							{{scope.row.datas[index]}}
						</template>
					</el-table-column>
				</el-table>
			
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
			</span>
		</el-dialog>
		
	</div>
</template>

<script>
	export default {
		components: {
			
		},
		data() {
			return {
				dialogVisible: false,
				rowData: {
					tableFormData1:{},
					tableFormData2:{},
					tableFormData3:{},
					tableFormData4:{},
					tableFormData5:{},
				},
				tableData: [],
				roundReportId:"",
			}
		},
		created() {

		},
		methods: {
			init(data) {
				this.$nextTick(() => {
					this.dialogVisible = true
					if (data) {
						this.roundReportId = data.dataKey
						this.getInfo()
					}
				})
			},
			// 查询
			getInfo() {
				let that = this;
				that.$request.post(
						"roundReportInfo",
						false, {
							roundReportId: that.roundReportId
						}
					)
					.then((res) => {
						if (res) {
							that.rowData = res.data
							that.rowData.tableFormData1= res.data.tableFormData1||{}
							that.rowData.tableFormData2= res.data.tableFormData2||{}
							that.rowData.tableFormData3= res.data.tableFormData3||{}
							that.rowData.tableFormData4= res.data.tableFormData4||{}
							that.rowData.tableFormData5= res.data.tableFormData5||{}
						}
					})
			},
			// 取消
			cancle() {
				this.dialogVisible = false
				this.$emit("getList")
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}

	.w90 {
		width: 110px;
	}

	.nc-box {
		padding: 10px;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
	}

	.mb10 {
		margin-bottom: 10px !important;
	}

	.w190 {
		width: 280px !important;
	}

	.info-box {
		/deep/ .el-dialog__body {
			// height: 330px;
			padding: 20px 20px 10px;
			overflow-y: auto;
		}
	}

	.info-title {
		background: #E5E5E5;
		color: #333;
		padding: 10px;
		box-sizing: border-box;
		font-size: 16px;
		font-weight: bold;

		img {
			vertical-align: bottom;
			display: block;
		}
	}

	.el-form-item {
		width: 420px;
	}

	.w330 {
		width: 330px;
	}

	.w420 {
		width: 420px !important;
		margin-right: 10px;
	}

	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
	}

	.opeartion {
		font-size: 18px;
	}

	.lh30 {
		line-height: 30px;
	}

	.el-table {

		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 5px;
		}

		/deep/ td {
			padding: 5px;
		}

	}

	.nc-box {
		padding: 10px;
		border-bottom: 1px solid #DCDFE6;
		color: #606266;
		font-size: 13px;
	}
	.info-name {
		display: inline-block;
		width: 140px;
		text-align: right;
		color: #999;
	}
</style>
